<template>
  <div class="PressCenter">
    <div class="setWidth titleImg">
      <img class="image" src="./img/MdNewsTitle.png" alt="" />
    </div>
    <div v-if="moreNews">
      <!-- 1 -->
      <div class="newsMerge" v-for="item in newsTitle" :key="item.ID">
        <p class="newsTitle">
          <span>{{ item.Name }}</span>
          <a href="javascript:;" @click="backNews(item)">查看更多</a>
        </p>
        <!-- <SwiperNews :news-title='item.Name' :news-id='item.ID' /> -->
        <!-- <div class="newsMergeBox">
          <div class="newsMergeList">
            <div class="newsMergeItem" v-for="i in 4" :key="i">
              <p class="newsMergeItemImg"> <img src="./img/pressthree.png" alt=""></p>
              <p class="newsMergeItemTitle">时空年底冲刺 | 全力以赴，时不我待！</p>
              <p class="newsMergeItemTime">2022-01-18</p>
            </div>
          </div>
        </div> -->
        <MdNewsList :news-id="item.ID" />
      </div>
    </div>
    <div v-if="!moreNews">
      <div class="newsMerge">
        <p class="newsTitle">
          <span>{{ moreNewsListTitle }}</span>
          <a href="javascript:;" @click="backNews">返回中心</a>
        </p>
        <div class="moreNewsBox">
          <div
            class="moreNewsBoxItem"
            v-for="item in moreNewsList"
            :key="item.ID"
            @click="goNewsItem(item)"
          >
            <div class="CNewItemImg">
              <!-- <img src="./img/pressone.png" alt=""> -->
              <el-image class="CNewItemImgSelf" :src="item.TitlePic">
                <div slot="error" class="image-slot">
                  <img src="~@/assets/img/noNews.png" alt="" />
                </div>
              </el-image>
            </div>
            <div class="CNewItemName">
              <p class="CNewItemNameI">{{ item.Title | cutString(18) }}</p>
              <p class="CNewItemNametime">{{ item.AddTime | timeFormat }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MdNewsList from "@/views/news/components/MdNewsList.vue";
// 获取新闻中心
import { getArticleApiIndex } from "@/api/news";
// 引入根路径
import request from "@/utils/request";
// 引入时间格式过滤
import { timeFormat } from "@/utils/myFilters";
import { cutString } from "@/utils/myCutString.js";
export default {
  components: { MdNewsList },
  data() {
    return {
      title: "aaaaaaa",
      title2: "wwwwwwwwwwww",
      title3: "rrrrrrrrr",
      title4: "eeeeeeeee",
      moreNews: false, // 控制是否显示更多
      // newsTitle: [] // 新闻分类
      moreNewsList: [], // 更多新闻
      moreNewsListTitle: "" // 更多新闻标题
    };
  },
  filters: {
    timeFormat,
    cutString
  },
  mounted() {
    this.moreNews = true;
    // this.newsTitle = this.$store.state.newsTitle
    // console.log('aaaaaaaaa')
  },
  computed: {
    newsTitle() {
      return this.$store.state.newsTitle;
    }
  },
  methods: {
    // 返回新闻中心
    backNews(item) {
      // console.log(item, '11111111')
      this.moreNews = !this.moreNews;
      // console.log(this.moreNews)
      this.moreNewsListTitle = item.Name;
      this.getArticleApiIndex({ TypeId: item.ID });
    },
    // 获取新闻中心
    async getArticleApiIndex(data) {
      const res = await getArticleApiIndex(data);
      // console.log(res, 'xinwenzhongx')
      if (res.Msg === "获取成功") {
        this.moreNewsList = res.Data;
        this.moreNewsList.sort((a, b) => {
          return b.ID - a.ID;
        });
        this.moreNewsList.forEach(item => {
          item.TitlePic = request.defaults.baseURL + item.TitlePic;
        });
      }
    },
    goNewsItem(item) {
      // this.$router.push(newsItem)
      this.$router.push({ path: `/newsItemNew/${item.ID}` });
    }
  }
};
</script>

<style lang="scss" scoped>
$md: 72/192 * 2;
.newsMergeBox {
  width: 750px / $md;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.newsMergeList {
  width: 690px / $md;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .newsMergeItem {
    width: 335px / $md;
    height: 345px / $md;
    background: #f8f8f8;
    margin-bottom: 26px / $md;
    p {
      margin-bottom: 16px / $md;
    }
    .newsMergeItemImg {
      width: 335px / $md;
      height: 209px / $md;
      img {
        width: 100%;
      }
    }
    .newsMergeItemTitle {
      font-size: 22px / $md;
      margin-left: 20px / $md;
      margin-right: 10px / $md;
    }
    .newsMergeItemTime {
      font-size: 20px / $md;
      margin-left: 20px / $md;
      margin-right: 10px / $md;
      color: #999999;
    }
  }
}
// 新闻类型组件结束
// pc高度比
// $sun:75/192;

.PressCenter {
  display: flex;
  justify-content: center;
  flex-direction: column;
  background-color: #ffffff;
}
.setWidth {
  margin-bottom: 50px / $md;
  width: 750px / $md;
  img {
    width: 100%;
  }
}
// 新闻标题
.newsMerge {
  margin-bottom: 50px / $md;
}
.newsTitle {
  display: flex;
  justify-content: space-between;
  width: 700px / $md;
  height: 50px / $md;
  margin: 0 auto;
  margin-bottom: 30px / $md;
  border-bottom: 2px / $md solid #e6e6e6;
  span {
    font-size: 26px / $md;
  }
  a {
    margin-top: 9px / $md;
    font-size: 22px / $md;
    color: #999;
  }
}
// 更多新闻
.moreNewsBox {
  width: 750px / $md;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding: 0 29px / $md;
  box-sizing: border-box;
  .moreNewsBoxItem {
    width: 335px / $md;
    height: 345px / $md;
    margin: 0 5px / $md;
    margin-bottom: 20px / $md;
    .CNewItemImg {
      width: 335px / $md;
      height: 209px / $md;
      margin: 0;
      img {
        width: 100%;
        height: 100%;
      }
      .el-image {
        width: 100%;
        height: 100%;
      }
    }
    .CNewItemName {
      width: 100%;
      height: 136px / $md;
      background: #f8f8f8;
      padding: 20px / $md;
      box-sizing: border-box;
      .CNewItemNameI {
        font-size: 24px / $md;
        margin: 0;
        height: 60px / $md;
        margin-bottom: 14px / $md;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      .CNewItemNametime {
        font-size: 20px / $md;
        margin: 0;
        color: #999999;
      }
    }
  }
  //     .moreNewsBoxItem:hover img{
  //       animation: move .5s linear forwards;
  //      }
  //     @keyframes move {
  //       0% {
  //         transform: scale(1);
  //       }
  //       100% {
  //         transform: scale(1.1);
  //       }
  //     }
  //      .moreNewsBoxItem:hover{
  //    /* 盒子向上移动 */
  //     transform: translateY(-2px*$sun);
  //     /* 背景 */
  //     box-shadow: 5px*$sun 5px*$sun 5px*$sun rgba(19, 19, 20, 0.15);
  //     // text-shadow: 5px*$sun 5px*$sun 5px*$sun #7676f3;
  //  }
}
// 新闻标题结束
</style>
